var map = {
	"../../../pages/qr-code/qr-code.module.ngfactory": [
		"tc7m",
		12
	],
	"../../../pages/scan-qrcode/scan-qrcode.module.ngfactory": [
		"y9Di",
		32
	],
	"../../../pages/verify-table-code/verify-table-code.module.ngfactory": [
		"qgHt",
		41
	],
	"../DineinOrTakeawayPage/DineinOrTakeawayPage.module.ngfactory": [
		"TTQ1",
		33
	],
	"../brand-faq/brand-faq.module.ngfactory": [
		"0+al",
		34
	],
	"../brand-store-list/brand-store-list.module.ngfactory": [
		"+zm+",
		0,
		15
	],
	"../item-grid/item-grid.module.ngfactory": [
		"AD3b",
		2,
		0,
		16
	],
	"../modifier-item-select/modifier-item-select.module.ngfactory": [
		"LSuu",
		18
	],
	"../pages/category-group-list/category-group-list.module.ngfactory": [
		"L+vw",
		0,
		23
	],
	"../pages/category-item-list/category-item-list.module.ngfactory": [
		"G7ku",
		2,
		0,
		35
	],
	"../pages/category-list/category-list.module.ngfactory": [
		"7gFu",
		0,
		24
	],
	"../pages/item-grid/item-grid.module.ngfactory": [
		"AD3b",
		2,
		0,
		16
	],
	"../pages/qr-code/qr-code.module.ngfactory": [
		"tc7m",
		12
	],
	"../pages/search-item/search-item.module.ngfactory": [
		"0iv1",
		2,
		0,
		39
	],
	"../pages/side-menu-category-list/side-menu-category-list-page.module.ngfactory": [
		"cko/",
		2,
		0,
		40
	],
	"./alipay-payment/alipay-payment.module.ngfactory": [
		"YWD8",
		0,
		43
	],
	"./byod-summary/byod-summary.module.ngfactory": [
		"eF/a",
		1,
		0,
		19
	],
	"./cart/cart.module.ngfactory": [
		"cYNU",
		1,
		2,
		0,
		42
	],
	"./cart/multi-order-cart/multi-order-cart.module.ngfactory": [
		"TEWH",
		1,
		2,
		0,
		17
	],
	"./credit-card-payment/credit-card-payment.module.ngfactory": [
		"Xeyw",
		0,
		44
	],
	"./eft-payment/eft-payment.module.ngfactory": [
		"N8o6",
		0,
		45
	],
	"./login/login.module.ngfactory": [
		"Q9+5",
		0,
		58
	],
	"./member-reward/member-reward.module.ngfactory": [
		"Jx/8",
		0,
		28
	],
	"./modifier-item-select/modifier-item-select.module.ngfactory": [
		"LSuu",
		18
	],
	"./mpgs-apple-pay-payment/mpgs-apple-pay-payment.module.ngfactory": [
		"z8L2",
		1,
		0,
		46
	],
	"./mpgs-credit-card-payment/mpgs-credit-card-payment.module.ngfactory": [
		"Lijj",
		0,
		47
	],
	"./mpgs-google-pay-payment/mpgs-google-pay-payment.module.ngfactory": [
		"sM2/",
		1,
		0,
		48
	],
	"./mpgs-host-session/mpgs-host-session.module.ngfactory": [
		"xbH0",
		0,
		49
	],
	"./multi-order-cart/multi-order-cart.module.ngfactory": [
		"TEWH",
		1,
		2,
		0,
		17
	],
	"./multi-order-detail/multi-order-detail.module.ngfactory": [
		"uh18",
		63
	],
	"./multi-order-history/multi-order-history.module.ngfactory": [
		"dKBQ",
		0,
		13
	],
	"./oepay-payment/oepay-payment.module.ngfactory": [
		"9qj0",
		1,
		0,
		50
	],
	"./openrice-payment/openrice-payment.module.ngfactory": [
		"SryB",
		0,
		51
	],
	"./order-detail/order-detail.module.ngfactory": [
		"JSSb",
		64
	],
	"./order-status/order-status.module.ngfactory": [
		"6Dmw",
		0,
		14
	],
	"./pages/brand-store-list/brand-store-list.module.ngfactory": [
		"+zm+",
		0,
		15
	],
	"./pages/byod-brand-splash/byod-brand-splash.module.ngfactory": [
		"8d1I",
		0,
		30
	],
	"./pages/byod-splash/byod-splash.module.ngfactory": [
		"gc8Q",
		0,
		25
	],
	"./pages/close/close.module.ngfactory": [
		"5pCk",
		36
	],
	"./pages/code/code-page.module.ngfactory": [
		"zSQ6",
		37
	],
	"./pages/delivery-information/delivery-information.module.ngfactory": [
		"WYxV",
		0,
		38
	],
	"./pages/test/test.module.ngfactory": [
		"Qy1k",
		0,
		31
	],
	"./pop-up-set-menu-withImg/pop-up-set-menu-withImg-page.module.ngfactory": [
		"IOuC",
		0,
		26
	],
	"./pop-up-set-menu/pop-up-set-menu.module.ngfactory": [
		"ouWR",
		0,
		27
	],
	"./profile/profile.module.ngfactory": [
		"p6xJ",
		59
	],
	"./redirect-payment/redirect-payment.module.ngfactory": [
		"sJc6",
		0,
		52
	],
	"./registration/registration.module.ngfactory": [
		"JWRA",
		0,
		60
	],
	"./reset-password/reset-password.module.ngfactory": [
		"OIZK",
		61
	],
	"./reward-list/reward-list.module.ngfactory": [
		"Xwuq",
		0,
		29
	],
	"./routes/summary/byod-summary/byod-summary.module.ngfactory": [
		"eF/a",
		1,
		0,
		19
	],
	"./routes/summary/multi-order-history/multi-order-history.module.ngfactory": [
		"dKBQ",
		0,
		13
	],
	"./routes/summary/order-status/order-status.module.ngfactory": [
		"6Dmw",
		0,
		14
	],
	"./saved-order-list/saved-order-list.module.ngfactory": [
		"QSay",
		66
	],
	"./set-sub-items/set-sub-items.module.ngfactory": [
		"UlqU",
		57
	],
	"./stripe-apple-payment/stripe-apple-payment.module.ngfactory": [
		"atIV",
		1,
		0,
		53
	],
	"./stripe-google-pay-payment/stripe-google-pay-payment.module.ngfactory": [
		"AXia",
		1,
		0,
		54
	],
	"./summary-list/summary-list.module.ngfactory": [
		"UMUz",
		0,
		67
	],
	"./summary/order-status-prekiosk/order-status-prekiosk.module.ngfactory": [
		"SHII",
		65
	],
	"./verify-registration/verify-registration.module.ngfactory": [
		"JMPQ",
		62
	],
	"./wechat-open-payment/wechat-open-payment.module.ngfactory": [
		"xCDo",
		0,
		55
	],
	"./wechat-pay-payment/wechat-pay-payment.module.ngfactory": [
		"+iLe",
		0,
		56
	],
	"src/app/pages/qr-code/qr-code.module.ngfactory": [
		"tc7m",
		12
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;